import React from 'react';
import { focusAndOpenKeyboardFixIOS } from 'src/helpers/comments';

import { Button, Icon } from '@sravni/react-design-system';
import { Message } from '@sravni/react-icons';

import { REDUX_STORE } from '../../../constants/common';
import { addArticleWithCommentsUserWantsToSee, selectMaterialByAlias } from '../../../reducers/news';
import { documentScrollHandler } from '../../../utils/scollHandler';

interface IProps {
  commentsCount?: number;
  canCreateNewComments: boolean;
  commentsRef?: React.RefObject<HTMLDivElement>;
  handleShowAuthPopup?: () => void;
  isUserLogged?: boolean;
  onClick?: () => void;
}

export const CommentsButton = ({
  commentsCount,
  canCreateNewComments,
  commentsRef,
  isUserLogged,
  handleShowAuthPopup,
  onClick,
}: IProps) => {
  if ((!commentsCount && !canCreateNewComments) || !canCreateNewComments) return null;

  const handleClick = () => {
    const { getState, dispatch } = window[REDUX_STORE];
    onClick?.();
    if (!commentsCount && !isUserLogged && handleShowAuthPopup) {
      handleShowAuthPopup();
    } else if (commentsRef) {
      const articleAlias = commentsRef.current.dataset.alias;
      const material = selectMaterialByAlias(getState())(articleAlias);
      dispatch(addArticleWithCommentsUserWantsToSee(material.id));

      setTimeout(() => {
        const topCoordinate = commentsRef.current.getBoundingClientRect().top + window.scrollY;
        documentScrollHandler.scrollTo({ behavior: 'smooth', top: topCoordinate });

        commentsRef && isUserLogged && focusAndOpenKeyboardFixIOS(commentsRef.current.querySelector('textarea'), 1000);
      }, 500);
    }
  };

  return (
    <Button size={36} variant="outlined" color="dark" onClick={handleClick} name={'Комментарии'}>
      {commentsCount > 0 && commentsCount} <Icon size={20} icon={<Message />} />
    </Button>
  );
};
